export const ELECTRIC_WAREHOUSE_SITE_NAME = 'Electric Warehouse';

/** Countries an asset can be deployed from a customer (non-global) site */
export const CUSTOMER_SITE_DEPLOY_COUNTRIES = ['US', 'CA'];

/** Countries an asset can be deployed from a warehouse (global site). Canada is not supported for now: a Canadian warehouse counts as international. */
export const WAREHOUSE_DEPLOY_COUNTRIES = ['US'];
